"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComposedBlur = void 0;
var _react = require("react");
const FOCUSABLE_ELEMENTS = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "iframe", "object", "embed", "[tabindex]:not([tabindex='-1'])"].join(",");
const useComposedBlur = _ref => {
  let {
    onBlur,
    onFocus,
    onMouseDown,
    onMouseUp
  } = _ref;
  const isFocusableClickedRef = (0, _react.useRef)(false);
  const blurTimeOutRef = (0, _react.useRef)(null);
  const isActiveRef = (0, _react.useRef)(false);

  /**
   * We should check if the user clicked an inside focusable element or not
   * since ther could be no next focusable element, sso the timeout should not
   * be triggered
   */
  const internalBlurHandler = (0, _react.useCallback)(evt => {
    if (isFocusableClickedRef.current) {
      isFocusableClickedRef.current = false;
      return;
    }
    blurTimeOutRef.current = setTimeout(() => {
      onBlur?.(evt);
      isActiveRef.current = false;
    });
  }, [onBlur]);
  const internalFocusHandler = (0, _react.useCallback)(evt => {
    if (blurTimeOutRef.current) clearTimeout(blurTimeOutRef.current);
    if (!isActiveRef.current) {
      isActiveRef.current = true;
      onFocus?.(evt);
    }
  }, [onFocus]);

  /**
   * Safari triggers a blur event when clicking but not a focus on the next element
   * So we have to check if we want to prevent the default on click or not
   * or set the hook to ignore blur the next time
   */
  const internalMouseDownHandler = (0, _react.useCallback)(evt => {
    // for clicks on flyout but not on a focusable element
    const isFocusTarget = !!evt.target.closest(FOCUSABLE_ELEMENTS);
    if (isFocusTarget) {
      isFocusableClickedRef.current = true;
    } else {
      evt.preventDefault();
    }
    onMouseDown?.(evt);
  }, [onMouseDown]);

  /**
   * Clean reference for cases when the user clicks again (since there could be no focus element)
   */
  const internalMouseUpHandler = (0, _react.useCallback)(evt => {
    isFocusableClickedRef.current = false;
    onMouseUp?.(evt);
  }, [onMouseUp]);
  (0, _react.useEffect)(() => {
    return () => {
      if (blurTimeOutRef.current) {
        clearTimeout(blurTimeOutRef.current);
      }
    };
  }, []);
  return {
    onBlur: internalBlurHandler,
    onFocus: internalFocusHandler,
    onMouseDown: internalMouseDownHandler,
    onMouseUp: internalMouseUpHandler
  };
};
exports.useComposedBlur = useComposedBlur;
//# sourceMappingURL=useComposedBlur.js.map